// Bootstrap.jsx — Decides whether to show the LoginGate or lazy-load the
// admin bundle.
//
// - Firebase configured + signed in → lazy-load <App/> (the admin bundle).
// - Firebase configured + not signed in → <LoginGate/>.
// - Firebase NOT configured (local dev) → straight to <App/> with the mock
//   data layer; no auth required.
//
// The admin chunk is dynamically imported via React.lazy so unauthenticated
// visitors only download Bootstrap + LoginGate, not UsersList / AuditLog /
// EventDetailModal.

import React, { Suspense } from "react";
import { LoginGate } from "./auth/LoginGate.jsx";
import { useAuth } from "./auth/useAuth.ts";
import { isFirebaseConfigured } from "./auth/firebaseClient.ts";

const AdminApp = React.lazy(() =>
  import("./ui/App.jsx").then((m) => ({ default: m.App }))
);

export function Bootstrap() {
  const { ready, user } = useAuth();
  const authRequired = isFirebaseConfigured();

  if (!ready) return <SplashScreen />;
  if (authRequired && !user) return <LoginGate />;

  return (
    <Suspense fallback={<SplashScreen />}>
      <AdminApp user={user} />
    </Suspense>
  );
}

function SplashScreen() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "linear-gradient(180deg, #10213A 0%, #0A1627 100%)",
      }}
    />
  );
}
